import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, text: string) {
  this.sendEvent('dev.test', { text })
}
